import { createStyles, Grid, makeStyles, Theme } from '@material-ui/core';
import React from 'react';

import {
  CODE_BLOCK_BACKGROUND_DARK,
  CODE_BLOCK_BACKGROUND_LIGHT,
  CODE_BLOCK_BORDER_DARK,
  CODE_BLOCK_BORDER_LIGHT,
} from '../../../styles/colors';
import { TnTypography } from '../../TnTypography';
import { HirevueQuestion } from '../types';

interface IProps {
  question: HirevueQuestion;
}

const codeBlockBackground = (theme: Theme) =>
  theme.palette.type === 'dark' ? CODE_BLOCK_BACKGROUND_DARK : CODE_BLOCK_BACKGROUND_LIGHT;

const codeBlockBorder = (theme: Theme) =>
  theme.palette.type === 'dark' ? CODE_BLOCK_BORDER_DARK : CODE_BLOCK_BORDER_LIGHT;

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    answerContainer: {
      flexDirection: 'column',
    },
    richText: {
      overflowWrap: 'break-word',
      whiteSpace: 'pre-wrap',
      '& p': {
        margin: 0,
      },
      '& img': {
        maxWidth: '100%',
      },
      maxHeight: 300,
      overflowY: 'scroll',
      backgroundColor: codeBlockBackground(theme),
      padding: 8,
      border: `1px solid ${codeBlockBorder(theme)}`,
      borderRadius: 4,
      maxWidth: '100%',
      width: '100%',
    },
    subDescription: {
      fontSize: '14px',
      fontWeight: 500,
      whiteSpace: 'pre-wrap',
    },
    promptContainer: {
      maxHeight: 300,
      overflowY: 'scroll',
      padding: 8,
      border: `1px solid ${codeBlockBorder(theme)}`,
      borderRadius: 4,
      maxWidth: '100%',
      width: '100%',
      overflowWrap: 'break-word',
      whiteSpace: 'pre-wrap',
      marginBottom: 16,
    },
  }),
);

const CodeChallenge: React.FC<IProps> = ({ question }) => {
  const classes = useStyles();

  const description = question?.codingChallengeQuestion?.description;
  const inputDescription = question?.codingChallengeQuestion?.input?.description;
  const outputDescription = question?.codingChallengeQuestion?.output?.description;
  const schema = question?.codingChallengeQuestion?.schema;

  return (
    <Grid className={classes.answerContainer} container justify="center" xs={6}>
      <TnTypography variant="subtitle">Prompt</TnTypography>
      <div className={classes.promptContainer}>
        <div className={classes.subDescription} dangerouslySetInnerHTML={{ __html: question?.text }} />
        {description && (
          <div>
            <TnTypography variant="subtitle">Description</TnTypography>
            <div className={classes.subDescription} dangerouslySetInnerHTML={{ __html: description }} />
          </div>
        )}
        {inputDescription && (
          <div>
            <TnTypography variant="subtitle">Input</TnTypography>
            <div className={classes.subDescription} dangerouslySetInnerHTML={{ __html: inputDescription }} />
          </div>
        )}
        {outputDescription && (
          <div>
            <TnTypography variant="subtitle">Ouput</TnTypography>
            <div className={classes.subDescription} dangerouslySetInnerHTML={{ __html: outputDescription }} />
          </div>
        )}
        {schema && (
          <div>
            <TnTypography variant="subtitle">Schema</TnTypography>
            <div className={classes.subDescription} dangerouslySetInnerHTML={{ __html: schema }} />
          </div>
        )}
      </div>

      <TnTypography variant="subtitle">Answer</TnTypography>
      <div dangerouslySetInnerHTML={{ __html: question?.textAnswer }} className={classes.richText} />
    </Grid>
  );
};

export default CodeChallenge;
